"use strict";
exports.__esModule = true;
exports.FLEX_ANYWHERE_HOW_YOU_PAY_CONTENT = void 0;
exports.FLEX_ANYWHERE_HOW_YOU_PAY_CONTENT = {
    HEADER: 'How to pay rent with Flex',
    FLYWHEEL_HEADER: 'Since your property isn’t integrated with Flex, here’s how you’ll pay rent with us:',
    MAIN_TEXT: 'Since your property is not integrated with Flex, we’ll need your help to submit your rent each month.',
    BODY_1: 'After you make your 1st payment to Flex, we’ll provide you with a Flex bank account.',
    BODY_2: 'Log into your property’s portal and use the Flex bank account info to submit your rent.',
    DISCLAIMER: 'Your rent portal may charge additional fees when paying with a card, which will be included in your payments to Flex.',
    CTA: 'Got it',
    FLYWHEEL_CTA: 'Got it, continue'
};
